<script>
import { nextTick } from "vue";
import { mapGetters } from "vuex";
import ProgressSpinner from "primevue/progressspinner";

export default {
  name: "LoadingOverlay",
  components: {
    ProgressSpinner,
  },

  data() {
    return {
      liveRegionMessage: "",
      clearLiveRegionTimeout: null,
    };
  },

  computed: {
    ...mapGetters(["isLoading"]),
    resolvedLoadingMessage() {
      const translatedText = this.$t("Loading");
      return translatedText === "Loading" ? "Loading" : translatedText;
    },
  },

  watch: {
    isLoading: {
      immediate: true,
      async handler(isLoading) {
        if (this.clearLiveRegionTimeout != null) {
          clearTimeout(this.clearLiveRegionTimeout);
          this.clearLiveRegionTimeout = null;
        }

        if (isLoading) {
          // Force a DOM text change so screen readers announce repeated loading events.
          this.liveRegionMessage = "";
          await nextTick();
          this.liveRegionMessage = this.resolvedLoadingMessage;
          return;
        }

        this.clearLiveRegionTimeout = setTimeout(() => {
          this.liveRegionMessage = "";
          this.clearLiveRegionTimeout = null;
        }, 500);
      },
    },
  },

  beforeUnmount() {
    if (this.clearLiveRegionTimeout != null) {
      clearTimeout(this.clearLiveRegionTimeout);
      this.clearLiveRegionTimeout = null;
    }
  },
};
</script>

<template>
  <div>
    <div class="visually-hidden" role="status" aria-live="polite" aria-atomic="true">
      {{ liveRegionMessage }}
    </div>
    <div v-if="isLoading" id="overlay" aria-hidden="true">
      <ProgressSpinner id="progress-spinner" strokeWidth="5" />
    </div>
  </div>
</template>

<style scoped>
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

#overlay {
  bottom: 0;
  left: 0;
  opacity: 0.75;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9997;
  background-color: rgba(77, 73, 73, 0.5); /* Black background with opacity */
}
#progress-spinner {
  width: 50px;
  height: 50px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -50px;
}
</style>
